// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { PostChangePasswordRequest } from '@models/usuarios.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  postChangePassword(postChangePasswordRequest: PostChangePasswordRequest): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Usuarios/ChangePassword`, postChangePasswordRequest, this.httpOptions);
  }

  postRecoverPassword(email: string): Observable<void> {
    let params: HttpParams = new HttpParams();
    params = params.set('email', email);

    return this.http.post<void>(`${this.globalService.apiUrl.url}/Usuarios/RecoverPassword`, null, { ...this.httpOptions, params });
  }
}